/** 基础接口 */
const dataFormat = 'form';

export default {
	base: {
		// 打卡列表
		signList: { url: 'weixin/signList', dataFormat },

		// 打卡
		sign: { url: 'weixin/sign', dataFormat },

		getUserScore: { url: 'weixin/getUserScore' },

		//获取订单列表
		orderList: { url: 'shopping/order/orderList' },

		//查看订单详情
		orderDetail: { url: 'shopping/order/detail', dataFormat },

		//获取导航列表
		getNavigationList: { url: 'gzsa/getNavigationList' },

		//根据栏目id获取文章列表
		getArticleByColumnId: { url: 'gzsa/getArticleByColumnId' },

		//根据文章id获取文章详情
		getArticleById: { url: 'gzsa/getArticleById' },

		//获取整个导航
		getHeadList: { url: 'gzsa/getHeadList' },

		//获取产品坑位列表
		getNavigationListByRank: { url: 'gzsa/getNavigationListByRank' },

		//获取banner
		getBannerListByRank: { url: 'gzsa/getBannerListByRank' },

		//获取banner
		getFloatBannerList: { url: 'gzsa/getFloatBannerList' },

		//获取友情链接列表
		getFriendLinkList: { url: 'gzsa/getFriendLinkList' },

		//数据统计
		addAcceptLog: { url: 'log/addAcceptLog' },

		/** 获取图片验证码 */
		getVerifiCode: { url: 'gzsa/getVerifiCode', method: 'get' },
		
		/** 校验图片验证码 */
		verifiCode: { url: 'gzsa/verifiCode' }
	}
}